/** Validation config shape for TextBox and TextArea controls */
export interface TextValidationConfig {
  minLength?: number;
  maxLength?: number;
  pattern?: string;         // JS regex string, e.g. "^[A-Z]"
  patternMessage?: string;  // Custom message when pattern fails
}

/** Validation config shape for Integer and Decimal controls */
export interface NumericValidationConfig {
  min?: number;
  max?: number;
}

/** Validation config shape for Picture, Attachment and Signature controls */
export interface FileValidationConfig {
  minCount?: number;
  maxCount?: number;
}

/** Validation config shape for Select control */
export interface SelectValidationConfig {
  minSelections?: number;
  maxSelections?: number;
}

/**
 * Validation config shape for DatePicker and DateTimePicker controls.
 * Use ISO date strings ("2025-01-01") or the special keyword "today".
 */
export interface DateValidationConfig {
  minDate?: string;
  maxDate?: string;
}

/** Validation config shape for Table control */
export interface TableValidationConfig {
  minRows?: number;
  maxRows?: number;
}

/**
 * Safely parse a raw JSON string into a typed validation config object.
 * Returns null when the string is empty or malformed — callers treat null as "no config".
 */
export function parseValidationConfig<T>(raw: string | null | undefined): T | null {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed === 'object' && parsed !== null) {
      return parsed as T;
    }
    return null;
  } catch {
    return null;
  }
}
